import { Attributes, LookupBase } from '@singularsystems/neo-core';
import { IncludeParticipantType } from './IncludeParticipantType';
import { TradingRestrictionFilterType } from './TradingRestrictionFilterType';

export default class TradingRestrictionLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly tradingRestrictionId: number = 0;

    public readonly restrictionName: string = "";

    public readonly requiresManualTradeRelease: boolean = false;

    public readonly requiresAuthorisedTradeRelease: boolean = false;

    public readonly batchTradesIndividually: boolean = false;

    public readonly preventTrading: boolean = false;

    public readonly showInLabel: boolean = false;

    public readonly labelColor: string = "";

    public readonly includeSales: boolean = true;

    public readonly includeSellToCovers: boolean = true;

    public readonly includeTransfers: boolean = true;

    @Attributes.Integer()
    public readonly participantCount: number = 0;

    @Attributes.Date()
    public readonly startDate: Date | null = null;

    @Attributes.Date()
    public readonly endDate: Date | null = null;

    public readonly includeParticipantType: IncludeParticipantType | null = null;

    public readonly filterType: TradingRestrictionFilterType | null = null;

    public readonly filterIds: number[] = [];

    @Attributes.Date()
    public readonly participantDisplayDate: Date | null = null;

    // Client only properties / methods

    public static filterForInstrumentAndSchemes(tradingRestrictions: TradingRestrictionLookup[], instrumentIds: number[], schemeIds: number[]): TradingRestrictionLookup[] {
        return tradingRestrictions
            .filter(c => c.filterType !== TradingRestrictionFilterType.Instrument || c.filterIds.some(id => instrumentIds.includes(id)))
            .filter(c => c.filterType !== TradingRestrictionFilterType.IncentiveScheme || c.filterIds.some(id => schemeIds.includes(id)));
    }
}